import { render, staticRenderFns } from "./TenderListLowHeaderCell.vue?vue&type=template&id=28f08d93&"
import script from "./TenderListLowHeaderCell.vue?vue&type=script&lang=js&"
export * from "./TenderListLowHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports